import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Stack, Typography } from '@mui/material';

export function RegistrationNotFound() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ p: 3, height: '100%', overflow: 'auto' }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={5}
        sx={{ paddingTop: '1.5rem', width: '100%' }}
      >
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            width: '100%',
            minHeight: 180,
            textAlign: 'center',
            alignContent: 'center'
          })}
        >
          <Typography variant="h3" component="h3" data-testid="primaryText">
            {t('eventRegistration.invalidRequest')}
          </Typography>
          <Typography
            variant="h6"
            component="h4"
            data-testid="secondaryText"
            sx={{ paddingTop: '1.5rem' }}
          >
            {t('eventRegistration.invalidCancellationText')}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}
